// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Your Referrals`
};

const de_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Empfehlungen`
};

const es_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Tus Referencias`
};

const fr_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Vos parrainages`
};

const fi_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Suosittelusi`
};

const hi_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `आपके रेफरल`
};

const ja_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `あなたの紹介`
};

const nl_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Uw verwijzingen`
};

const pt_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Suas indicações`
};

const ro_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Recomandările tale`
};

const th_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `การแนะนำของคุณ`
};

const ur_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `آپ کی سفارشات`
};

const zh_hant1_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `您的推薦`
};

const da_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Dine henvisninger`
};

const it_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `I Tuoi Referral`
};

const vn_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Giới Thiệu Của Bạn`
};

const ko_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `내 추천`
};

const tr_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Referanslarınız`
};

const lv_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Jūsu atsauces`
};

const ar_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `إحالاتك`
};

const bs_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Vaše preporuke`
};

const sl_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Vaša priporočila`
};

const id_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Referral Anda`
};

const sv_widget_stats_your_referrals = /** @type {(inputs: {}) => string} */ () => {
	return `Dina hänvisningar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_stats_your_referrals = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_stats_your_referrals(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_stats_your_referrals", locale)
	if (locale === "en") return en_widget_stats_your_referrals(inputs)
	if (locale === "de") return de_widget_stats_your_referrals(inputs)
	if (locale === "es") return es_widget_stats_your_referrals(inputs)
	if (locale === "fr") return fr_widget_stats_your_referrals(inputs)
	if (locale === "fi") return fi_widget_stats_your_referrals(inputs)
	if (locale === "hi") return hi_widget_stats_your_referrals(inputs)
	if (locale === "ja") return ja_widget_stats_your_referrals(inputs)
	if (locale === "nl") return nl_widget_stats_your_referrals(inputs)
	if (locale === "pt") return pt_widget_stats_your_referrals(inputs)
	if (locale === "ro") return ro_widget_stats_your_referrals(inputs)
	if (locale === "th") return th_widget_stats_your_referrals(inputs)
	if (locale === "ur") return ur_widget_stats_your_referrals(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_stats_your_referrals(inputs)
	if (locale === "da") return da_widget_stats_your_referrals(inputs)
	if (locale === "it") return it_widget_stats_your_referrals(inputs)
	if (locale === "vn") return vn_widget_stats_your_referrals(inputs)
	if (locale === "ko") return ko_widget_stats_your_referrals(inputs)
	if (locale === "tr") return tr_widget_stats_your_referrals(inputs)
	if (locale === "lv") return lv_widget_stats_your_referrals(inputs)
	if (locale === "ar") return ar_widget_stats_your_referrals(inputs)
	if (locale === "bs") return bs_widget_stats_your_referrals(inputs)
	if (locale === "sl") return sl_widget_stats_your_referrals(inputs)
	if (locale === "id") return id_widget_stats_your_referrals(inputs)
	if (locale === "sv") return sv_widget_stats_your_referrals(inputs)
	return "widget_stats_your_referrals"
};